import React from "react";
import { Route } from "react-router-dom";

const PublicRoute = ({ id, exact, path, render }) => {
  return <Route name={id} exact={exact} path={path} render={render} />;
};

export default PublicRoute;
